import gql from 'graphql-tag';

export const getMultiBuildingInspectionInstancesQuery = gql`
  query getMultiBuildingInspectionInstances(
    $channelIds: [UUID!]
    $search: InspectionInstanceSearchInput
    $pagination: PaginationInput!
  ) {
    multiBuildingInspectionInstances(
      channelIds: $channelIds
      search: $search
      pagination: $pagination
    ) {
      inspectionInstances {
        id
        schemaVersion
        version
        templateRef {
          templateId
          version
          templateName
        }
        metadata {
          buildingId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          tenantId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          suiteId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          assignedTo
          scheduledFor
          scheduleId
          createdAt
          createdBy
          createdByUser {
            _id
            name
          }
        }
        state {
          status
          startedAt
          completedAt
          completedBy
          completedByUser {
            _id
            name
          }
          closedReason
          progress {
            totalItems
            completedItems
            requiredItems
            completedRequiredItems
            sectionProgress {
              sectionId
              total
              completed
            }
          }
        }
        deficienciesCount
        serviceRequestsCount
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
